import { useState, useCallback } from 'react';

import { getOrgControlDetails } from 'admin2/OhsAdmin2Services';
import { OhsUser } from 'user/OhsUser';

import { getReportsRouteList } from './OhsReportsRouteLists';

function useReportsRouteList() {
  const [menu, setMenu] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const getReportsMenu = useCallback(async (user: OhsUser | undefined) => {
    setLoading(true);

    let control: any = null;
    try {
      if (user && user.tierNum > 2) {
        control = await getOrgControlDetails(user.tier._id);
      }
    } catch (err) {
      console.error('Failed to load org control details', err);
      // fallback leaves control as false
    }

    const list = getReportsRouteList(user, control);
    setMenu(list);
    setLoading(false);
  }, []);

  return { menu, loading, getReportingList: getReportsMenu };
}
export default useReportsRouteList;
